import {connect} from 'react-redux';

import {
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {makeGetConversation} from '../../../../../../store/data/conversations/conversationsSelectors';
import {ConversationHeaderAiSimilarDropdownConversation} from './conversationHeaderAiSimilarDropdownConversation';

/*
 * Props.
 */

interface ConversationHeaderAiSimilarDropdownConversationContainerProps {
  conversationId: number;
}

/*
 * Selectors.
 */

function getConversationId(
  _state: unknown,
  props: ConversationHeaderAiSimilarDropdownConversationContainerProps,
) {
  return props.conversationId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ConversationHeaderAiSimilarDropdownConversationContainerProps>()(
  () => ({
    conversation: wrapInShallowSelector(makeGetConversation(getConversationId)),
  }),
);

export const ConversationHeaderAiSimilarDropdownConversationContainer = connect(mapStateToProps)(
  ConversationHeaderAiSimilarDropdownConversation,
);
